import Headroom from 'headroom.js';

const Header = () => {

    let elem = document.querySelector("nav");
    let headerClass;
    let topClass;
    let pinnedClass = 'nav--slideUp';
    let unpinnedClass = 'nav--slideDown';

    let options = {
        "offset": 100,
        "tolerance": 0,
        "classes": {
            "initial": `${headerClass}`,
            "pinned": `${pinnedClass}`,
            "unpinned": `${unpinnedClass}`,
            "top": `${topClass}`,
        },

        onTop: function () {
            elem.classList.remove('nav--slideUp');
        }
    }

    let headroom = new Headroom(elem, options);

    headroom.init();

};

export default Header;


// WEBPACK FOOTER //
// ./src/js/app/components/Header.js